export function ResultTable({
  headers,
  children,
}: {
  headers: string[]
  children: React.ReactNode
}) {
  return (
    <div className="overflow-x-auto rounded-lg">
      <table className="w-full border-collapse min-w-[280px]">
        <thead>
          <tr className="active-gradient">
            {headers.map((header) => (
              <th
                key={header}
                className="px-4 py-3 text-center text-base font-bold uppercase tracking-wider text-[var(--tab-text-active)]"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}

export function ResultRow({
  idx,
  children,
}: {
  idx: number
  children: React.ReactNode
}) {
  return (
    <tr
      className="border-b border-[var(--card-divider)]"
      style={{
        backgroundColor:
          idx % 2 === 0 ? 'var(--card-bg)' : 'var(--table-row-alt)',
      }}
    >
      {children}
    </tr>
  )
}
